var appEnv, s3region, s3rootfolder, s3envfolder, crawlerUserId;
var endpoints = {};
var isLocalHost = window.location.hostname === "localhost";

const universalAssayOptions = [
  { name: "None", value: "null", fluorophores: "" },
  { name: "AAV ITR-2 (FAM)", value: "dEXD15274642", fluorophores: "FAM" },
  { name: "AAV ITR-2 (HEX)", value: "dEXD23004642", fluorophores: "HEX" },
  {
    name: "CMV promoter (FAM)",
    value: "dEXD96423937",
    fluorophores: "FAM",
  },
  {
    name: "CMV promoter (HEX)",
    value: "dEXD70693710",
    fluorophores: "HEX",
  },
  {
    name: "CMV promoter (Cy5.5)",
    value: "dEXD30054188",
    fluorophores: "Cy5_5",
  },

  {
    name: "CMV enhancer (FAM)",
    value: "dEXD44963483",
    fluorophores: "FAM",
  },
  {
    name: "CMV enhancer (HEX)",
    value: "dEXD19233256",
    fluorophores: "HEX",
  },
  { name: "eGFP (FAM)", value: "dEXD45075072", fluorophores: "FAM" },
  { name: "eGFP (HEX)", value: "dEXD22434642", fluorophores: "HEX" },
  { name: "hGFP (HEX)", value: "dEXD96535526", fluorophores: "HEX" },
  { name: "hGFP (FAM)", value: "dEXD72134642", fluorophores: "FAM" },
  { name: "SV40 poly A (FAM)", value: "dEXD19344845", fluorophores: "FAM" },
  { name: "SV40 poly A (HEX)", value: "dEXD83614618", fluorophores: "HEX" },
  { name: "SV40 poly A (Cy5)", value: "dEXD55784415", fluorophores: "Cy5" },
  { name: "BGH poly A (FAM)", value: "dEXD57884391", fluorophores: "FAM" },
  { name: "BGH poly A (HEX)", value: "dEXD32154164", fluorophores: "HEX" },
  { name: "HGH poly A (FAM)", value: "dEXD97544642", fluorophores: "FAM" },
  { name: "HGH poly A (HEX)", value: "dEXD71814415", fluorophores: "HEX" },
];

switch (window.location.hostname) {
  case "qa.bio-rad.com":
  case "www.qa.bio-rad.com":
  case "d1x8ea00rnkjib.cloudfront.net":
    appEnv = "test";
    s3region = "us-west-2";
    s3rootfolder = "dbg-digital-assays-data-test";
    crawlerUserId = "2df53be2ec604575a44e17c7c87f266e";

    endpoints = {
      main: "https://oqbnrzc33c.execute-api.us-west-2.amazonaws.com/test",
      assets: "https://d198dsizlynt3s.cloudfront.net",
      session: "https://qa.bio-rad.com",
      evoCart: "https://qa.bio-rad.com/qa",
    };

    break;

  case "www.b2b-uat.bio-rad.com":
  case "d2dc5q1pypn0iy.cloudfront.net":
    appEnv = "test";
    s3region = "us-west-2";
    s3rootfolder = "dbg-digital-assays-data-test";
    crawlerUserId = "2df53be2ec604575a44e17c7c87f266e";

    endpoints = {
      main:
        "https://79p905da8a.execute-api.us-west-2.amazonaws.com/future_release_test",
      assets: "https://d198dsizlynt3s.cloudfront.net",
      session: "https://www.b2b-uat.bio-rad.com",
      evoCart: "https://www.b2b-uat.bio-rad.com/uat2",
    };

    break;

  case "bio-rad.com":
  case "www.bio-rad.com":
  case "dqq0fs7dxsgvv.cloudfront.net":
    appEnv = "prod";
    s3region = "us-west-2";
    s3rootfolder = "dbg-digital-assays-data-prod";
    crawlerUserId = "9c8b9aa9db3e428d89d3e90350ef259f";

    endpoints = {
      main: "https://fppl7sm01k.execute-api.us-west-2.amazonaws.com/prod",
      assets: "https://d1vjebusapavbw.cloudfront.net",
      session: "https://www.bio-rad.com",
      evoCart: "https://www.bio-rad.com/prd",
    };

    break;
  default:
    appEnv = "dev";
    s3region = "us-west-2";
    s3rootfolder = "dbg-digital-assays-data-dev";
    endpoints = {
      main: isLocalHost
        ? "https://79p905da8a.execute-api.us-west-2.amazonaws.com/future_release_test"
        : "https://hvzfj56rm5.execute-api.us-west-2.amazonaws.com/dev",
      //DEV assets: "https://d1pv6wgoboysg7.cloudfront.net",
      assets: "https://d198dsizlynt3s.cloudfront.net",
      session: "https://lsds-int-dev1.br.aws-livesite.io", //use per deepak 9/9/2020
      evoCart: "https://lsds-int-dev1.br.aws-livesite.io/idev",
    };
}

export const UNIVERSAL_ASSAY_OPTIONS = universalAssayOptions;
export const CRYPTO_KEY = process.env.CRYPTO_KEY;
export const CRYPTO_SEED = process.env.CRYPTO_SEED;
export const APPENV = appEnv;
export const S3REGION = s3region;
export const S3ROOTFOLDER = s3rootfolder;
export const S3ENVFOLDER = s3envfolder;
export const ENDPOINTS = endpoints;
export const ISLOCALHOST = isLocalHost;
export const CRAWLERUSERID = crawlerUserId;
export const CRAWLERS = ["LuaSocket 3.0-rc1"];
